export function normalizeFloat(value: number): number {
  const factor = 100;
  return Math.round(value * factor) / factor;
}

export function getRandomInteger(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}